import { render, staticRenderFns } from "./vueHistoryDetails.vue?vue&type=template&id=83d7ad06&scoped=true"
import script from "./vueHistoryDetails.vue?vue&type=script&lang=js"
export * from "./vueHistoryDetails.vue?vue&type=script&lang=js"
import style0 from "./vueHistoryDetails.vue?vue&type=style&index=0&id=83d7ad06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d7ad06",
  null
  
)

export default component.exports